<template>
  <div class="container" id="playout">
    <headerTempSmall v-if="isRouterAlive"/>
    <div class="content">
      <router-view v-if="isRouterAlive"></router-view>
    </div>
    <footerTempSmall v-if="isRouterAlive" @scrollTop="scrollTop" @handleChange="handleChange"/>
    <img class="coupon" :src="`${$g.imgPrefix}/img/home/Group1000005850@2x.webp`" @click="openCoupon">
    <coupon ref="coupon"/>
  </div>
</template>
<script>
// import { getUserInfo } from "@/util/util";
import Bus from "@/util/Bus";
import {logoutToken} from "@/request/requests";
import headerTempSmall from "../phone/headerTemp";
import footerTempSmall from "../phone/footerTemp";
import coupon from "@/components/coupon";
export default {
  name: "Playout",
  components: {
    headerTempSmall,
    footerTempSmall,
    coupon
  },
  provide() {
    return {
      reload: this.reload,
      reloadApp:this.reload
    };
  },
  mounted() {
    this.checkToken();
    this.language = localStorage.lang;
    const crispClientElements = document.getElementsByClassName('crisp-client');
    for (let i = 0; i < crispClientElements.length; i++) {
      crispClientElements[i].style.display = 'block';
    }
  },
  data() {
    return {
      language: "",
      name: "",
      isRouterAlive: true,
      tokens: '',
      loginname: this.tokens ? this.$t("userinfo.signout") : this.$t("login.login"),
    };
  },
  watch: {
    "$route.path": function () {
      this.SelectedKeys = [this.$route.path];
    },
  },
  methods: {
    openCoupon(){
      this.$nextTick(()=>{
        this.$refs['coupon'].init();
      })
    },
    scrollTop(id){
      const yOffset = -40;
      const element = document.getElementById(id);
      const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
      window.scrollTo({top: y, behavior: 'smooth'});
    },
    handleChange(value) {
      Bus.$emit('switchLanguage', value)
      this.reload()
      this.scrollTop('playout')
    },
    tohome() {
      this.$router.push({path: "home"});
    },
    initData() {
      let info = this.$cookies.get("userInfo");
      if (info) {
        let {name} = JSON.parse(info);
        this.name = name;
      }
    },
    reload() {
      this.isRouterAlive = false;
      this.$nextTick(() => (this.isRouterAlive = true));
    },
    async checkToken() {
      window.console.log("---------layout");
      //先注释掉
      // let now = new Date().getTime();
      // let deadline = this.$cookies.get("deadline");
      // let token = this.$cookies.get("token");
      // let userInfo = this.$cookies.get("userInfo");
      // if (!deadline || !token || !userInfo) {
      //   // return this.$router.push({ name: "login" });
      //   if ("ontouchstart" in document.documentElement) {
      //     //   return this.$router.push({ name: "phonelogin" });
      //   } else {
      //     return this.$router.push({ name: "login" });
      //   }
      // }
      // if (deadline < now) {
      //   if ("ontouchstart" in document.documentElement) {
      //     //   return this.$router.push({ name: "phonelogin" });
      //   } else {
      //     return this.$router.push({ name: "login" });
      //   }
      // }
      this.initData();
    },
    // 登陆
    tologin(flage) {
      // this.$router.push({ path: "/phone/phonelogin" });
      if (flage === 4) {

        // this.$router.push({ path: "/phonelogin" });
        this.$router.push({name: "phelpdetail", query: {id: 10}});
      }
      this.tokens = this.$cookies.get("token")
      if (!this.tokens) {
        this.$router.push({name: "phonelogin"});
      } else {
        if (flage === 1) {
          // this.$router.push({ path: "/phonelogin" });
          this.$router.push({name: "psubscribe"});
        }
        if (flage === 2) {
          // this.$router.push({ path: "/phonelogin" });
          this.$router.push({name: "paftersales"});
        }
        if (flage === 3) {
          // this.$router.push({ path: "/phonelogin" });
          this.$router.push({name: "pfriends"});
        }
        if (flage === 5) {

          // this.$router.push({ path: "/phonelogin" });
          this.$router.push({name: "pnfcode"});
        }
      }
    },
    tosubscribe() {
      this.tokens = this.$cookies.get("token")
      if (this.tokens) {
        this.$router.push({name: "psubscribe"});
      } else {
        this.$router.push({name: "phonelogin"});
      }
    },
    // 退出登陆
    lognout() {
      // this.$confirmel('Are you sure you want to log out?', 'Tips', {
      this.$confirmel("로그아웃하시겠습니까??", "팁", {
        // confirmButtonText: 'comfirm',
        confirmButtonText: "확인",
        // cancelButtonText: 'cancel',
        cancelButtonText: "취소",
        type: "warning",
      })
          .then(() => {
            this.logout();
          })
          .catch(() => {
          });
    },
    async logout() {
      sessionStorage.removeItem("userInfo");
      sessionStorage.removeItem("deadline");
      await logoutToken();
      sessionStorage.removeItem("token");
      // this.$router.push({ path: "login" })
      if ("ontouchstart" in document.documentElement) {
        this.$router.push({name: "phonehome"});
      } else {
        return this.$router.push({name: "phonelogin"});
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.content{
  padding:31px 0 40px 0;
}
.coupon{
  position: fixed;
  right: 20px;
  bottom: 92px;
  width: 43px;
  z-index: 99;
  animation: coupon 3s infinite;
}
@keyframes coupon {
  0% {
    transform: translateX(-10px) rotate(20deg);
  }
  50% {
    transform: translateX(10px) rotate(-20deg);
  }
  100% {
    transform: translateX(-10px) rotate(20deg);
  }
}
</style>

<!--<style lang="scss">-->
<!--html,-->
<!--body {-->
<!--  width: 100%;-->
<!--  height: 100%;-->
<!--  font-size: 16px;-->
<!--}-->

<!--:root {-->
<!--  &#45;&#45;primary-050: #f4fffc;-->
<!--  &#45;&#45;primary-100: #eafff7;-->
<!--  &#45;&#45;primary-200: #d0ffed;-->
<!--  &#45;&#45;primary-300: #a2f5d5;-->
<!--  &#45;&#45;primary-400: #84eac3;-->
<!--  &#45;&#45;primary-500: #53e3ac;-->
<!--  &#45;&#45;primary-600: #4dca9a;-->
<!--  &#45;&#45;primary-700: #32b986;-->
<!--  &#45;&#45;primary-800: #24966b;-->
<!--  &#45;&#45;primary-900: #136b4a;-->
<!--  &#45;&#45;yellow-050: #fff7dc;-->
<!--  &#45;&#45;yellow-100: #feedb4;-->
<!--  &#45;&#45;yellow-200: #fee283;-->
<!--  &#45;&#45;yellow-300: #fed850;-->
<!--  &#45;&#45;yellow-400: #ffd324;-->
<!--  &#45;&#45;yellow-500: #ffb700;-->
<!--  &#45;&#45;yellow-600: #ffa400;-->
<!--  &#45;&#45;yellow-700: #ff7300;-->
<!--  &#45;&#45;red-050: #ffecee;-->
<!--  &#45;&#45;red-100: #ffc8d1;-->
<!--  &#45;&#45;red-200: #f89096;-->
<!--  &#45;&#45;red-300: #f1626d;-->
<!--  &#45;&#45;red-400: #fd3049;-->
<!--  &#45;&#45;red-500: #ff002a;-->
<!--  &#45;&#45;red-600: #f4002a;-->
<!--  &#45;&#45;red-700: #d6001c;-->
<!--  &#45;&#45;blue-050: #e6f2ff;-->
<!--  &#45;&#45;blue-100: #bbdcff;-->
<!--  &#45;&#45;blue-200: #8fc7ff;-->
<!--  &#45;&#45;blue-300: #60b0ff;-->
<!--  &#45;&#45;blue-400: #3e9fff;-->
<!--  &#45;&#45;blue-500: #1290fe;-->
<!--  &#45;&#45;blue-600: #1b6fdb;-->
<!--  &#45;&#45;blue-700: #1b5ec9;-->
<!--  &#45;&#45;gray-050: #f8f9fd;-->
<!--  &#45;&#45;gray-100: #f1f3f7;-->
<!--  &#45;&#45;gray-200: #e9ebec;-->
<!--  &#45;&#45;gray-300: #c5c8ce;-->
<!--  &#45;&#45;gray-400: #aeb4bf;-->
<!--  &#45;&#45;gray-500: #89939f;-->
<!--  &#45;&#45;gray-600: #646f7c;-->
<!--  &#45;&#45;gray-700: #454b53;-->
<!--  &#45;&#45;gray-800: #282b30;-->
<!--  &#45;&#45;gray-900: #1b1c1f;-->
<!--  &#45;&#45;white: #ffffff;-->
<!--  &#45;&#45;black: #121212;-->
<!--  &#45;&#45;blacks: #081118;-->
<!--  &#45;&#45;bj: #22272d;-->
<!--  &#45;&#45;shadow-low: 0 2px 8px 0 rgba(0, 0, 0, 0.1);-->
<!--  &#45;&#45;shadow-medium: 0 4px 16px 0 rgba(0, 0, 0, 0.12);-->
<!--  &#45;&#45;shadow-high: 0 8px 36px 0 rgba(0, 0, 0, 0.15);-->
<!--  -webkit-tap-highlight-color: transparent;-->
<!--}-->

<!--#playout {-->
<!--  font-family: SourceHanSansCN-Regular;-->
<!--  color: #fff;-->

<!--  .header-box {-->
<!--    background-color: var(&#45;&#45;blacks);-->
<!--    padding: 0 10px;-->
<!--    display: flex;-->
<!--    justify-content: space-between;-->
<!--    align-items: center;-->

<!--    .header-right {-->
<!--      display: flex;-->
<!--      justify-content: center;-->
<!--      align-items: center;-->
<!--    }-->
<!--  }-->

<!--  .header-logo img {-->
<!--    display: flex;-->
<!--    width: 25vw;-->
<!--    background-size: contain;-->
<!--  }-->

<!--  .user-img {-->
<!--    display: flex;-->
<!--    margin-right: 3vw;-->
<!--  }-->

<!--  /* 页脚 */-->

<!--  .footer-box {-->
<!--    /* background-color: #1a1a1a; */-->
<!--    background-color: #0d1821;-->
<!--    /* background-color:rgb(25, 43, 55); */-->
<!--    /* background-color: #001522; */-->
<!--  }-->

<!--  .footer-content-box {-->
<!--    /* display: flex;-->
<!--    justify-content: center;-->
<!--    align-items: center; */-->
<!--    /* background-color: #1a1a1a; */-->
<!--    /* background-color:rgb(25, 43, 55); */-->
<!--    /* background-color: #001522; */-->
<!--  }-->

<!--  .payment-box {-->
<!--    display: flex;-->
<!--    align-items: center;-->
<!--    flex-wrap: wrap;-->
<!--    justify-content: center;-->
<!--  }-->

<!--  .payment-content-box {-->
<!--    display: flex;-->
<!--    flex-wrap: wrap;-->
<!--    width: 100vw;-->
<!--    justify-content: center;-->
<!--  }-->

<!--  .payment-title {-->
<!--    color: hsla(0, 0%, 100%, 0.7);-->
<!--    margin: 0.5rem;-->
<!--    font-weight: bold;-->
<!--    font-size: 14px;-->
<!--    line-height: 21px;-->
<!--  }-->

<!--  .payment-img {-->
<!--    background-size: contain;-->
<!--    width: 20vw;-->
<!--    height: 6vh;-->
<!--    margin: 1rem;-->
<!--  }-->

<!--  .footer-content-gs {-->
<!--    background-color: #000;-->
<!--    font-weight: bolder;-->
<!--    font-size: 8px;-->
<!--    padding: 10px;-->
<!--    color: rgb(62, 77, 83);-->
<!--    display: flex;-->
<!--    flex-wrap: wrap;-->
<!--    justify-content: center;-->
<!--  }-->

<!--  .footer-content-gs-content {-->
<!--    width: 80vw;-->
<!--  }-->

<!--  // 详情 弹窗-->
<!--  .popup-details {-->
<!--    border-radius: 16px 16px 0 0;-->
<!--    padding: 0.8rem;-->

<!--    .details-header-box {-->
<!--      display: flex;-->
<!--      align-items: center;-->
<!--      justify-content: flex-start;-->
<!--    }-->

<!--    .details-header-box {-->
<!--    }-->
<!--  }-->

<!--  .darwer-box {-->
<!--    color: #000;-->
<!--    padding: 20px;-->
<!--    position: relative;-->
<!--  }-->

<!--  .content-item {-->
<!--    font-weight: 900;-->
<!--  }-->

<!--  .pay-button {-->
<!--    color: #ffffff;-->
<!--    background-color: #43d98e;-->
<!--    height: 5vh;-->
<!--    border-radius: 20px;-->
<!--    border: 1px solid;-->
<!--    width: 100%;-->
<!--  }-->
<!--}-->
<!--</style>-->
